
import React, { Component } from "react";
import {Icon, Rate, Button, Row, Col, Badge} from 'antd'


const {Link} = require("react-router")

class FlyLocationSVPriceListView extends Component {

    getFSKReserveHtmlButton(o,svcustProfile){
        let customerId = -1
        if(!svcustProfile){
            return (<Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svflysearch/svredfly/${o.flight_space_key}`}>Fly Reserve  </Link></Button>)
            
        }
        if(typeof(svcustProfile.customerId) == "string"){
            customerId = parseInt(svcustProfile.customerId )
        }else{
            customerId = svcustProfile.customerId
        }
       console.log("customerId:", customerId)
        if(customerId > 0){
            return (<Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myflyreservationsSV/${customerId}/flyressvCustNew/${o.flight_space_key}`}> MyFlightReserve  </Link></Button>)
            

        }else{

            return (<Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svflysearch/svredfly/${o.flight_space_key}`} state={{ svoffer: "occupation" }}> IReserve  </Link></Button>)
            
        }
        
    }
    constructor(props) {
        super(props)
        this.getFSKReserveHtmlButton = this.getFSKReserveHtmlButton.bind(this)
      
        this.location = {
            "resort_name": "253 Mancreek Resort",
            "address_line1": " 253 scottland av",
            "county": "albanyt",
            "postalcode": 12193,
            "market_code": "NAMER",
            "country": "usa",
            "region_desc_en": [
                "United States",
                "Coastal Mid Atlantic"
            ],
            "state": "NY",
        }

        this.getFSKReserveHtmlButton = this.getFSKReserveHtmlButton.bind(this)
        //this.getHotelAmenityList = this.getHotelAmenityList.bind(this)
        this.deleteTaskCurryParams  = this.deleteTaskCurryParams.bind(this)

    }

    deleteTaskCurryParams = (param1, ctx)=>(event)=>{
        console.log(param1)
		let me = ctx
		me.currentSelection = param1.sojourncode
		console.log('sv delete task curry')
		console.log(param1.sojourncode)
		//me.props.svWrappedDeleteTaskActionCreator(param1.id)
	}
   

    render() {
        /*
 let svr_fly = {
      "startdate": soj['startdate'] ? soj['startdate'] : "06:30",
                                        "enddate": soj['enddate'] ? soj['enddate'] : "7:30",
                                        "flight_arrival_daytime": soj['flight_arrival_daytime'] ? soj['flight_arrival_daytime'] : "AM",
                                        "flight_departure_daytime": soj['flight_departure_daytime'] ? soj['flight_departure_daytime'] : "PM",

                                        "origin_airport_code": soj['origin_airport_code'] ? soj['origin_airport_code'] : "SJC",
                                        "origincity": soj['origincity'] ? soj['origincity'] : "Sajn Jose",
                                        "dst_airport_code": soj['dst_airport_code'] ? soj['dst_airport_code'] : "AUS",
                                        "destcity": soj['destcity'] ? soj['destcity'] : "Austin",
                                        "airlines_name": soj['airlines_name'] ? soj['airlines_name'] : "Delta Airlines",
                                        

                                    }
        */
        const ars = [];
        let svrstars = {
            "sv_rating_no": 5,
            "sv_rating":"Excellent",
            "color": "#e8a01899"
        }
        console.log('############### this.props.svrlocation ****************')
        console.log(this.props.svrlocation)
        let customerId = -1
        const {svcustProfile, priceInfo} = this.props
        //const {o} = priceInfo
        let o = {
            product_cost_amount : '1030',
            avg_stars_rating : 5,
            flight_space_key: "1@4@1@ADQ"
        }
        console.log('############### price ****************')
        console.log(o)
        let flight_owner_message = 'Delta operated by SV DBA Deltaz Connection'
        let fltight_name = ''
        const {flight_operated_by, flight_operator_owned , airlines_name, airlines_code_iata, 
            airlines_name_iata,flight_airline_num_stops,flight_time_hhmm} = this.props.svrlocation
            const {flight_space_key} = this.props.svrlocation
        if(flight_space_key){
            o.flight_space_key = flight_space_key
        }
       
        if(flight_operator_owned && flight_operator_owned == 'Y'){
            flight_owner_message = flight_operated_by
        }
        if(airlines_name_iata && airlines_name_iata.length > 0){
            fltight_name = fltight_name + airlines_name_iata

        }
        if(airlines_code_iata ){
            fltight_name = fltight_name + airlines_code_iata

        }
        if(svcustProfile && svcustProfile.customerId ){
            if(typeof(svcustProfile.customerId) == "string"){
                customerId = parseInt(svcustProfile.customerId )
            }else{
                customerId = svcustProfile.customerId
            }
            if(customerId > 0){
           console.log('myreservationSpace')
           }else{
            console.log('internet userSpace')
           }
        }

        return (

            <div className="o-container-flist">
            <div className="o-box-flist-b1">
                    <span className="o-span">
                       
                            
                                   
                                
                                <span>
                                <p className="m-para-text">
                                <span style={{fontSize: "14px"}} > <Icon  style={{ fontSize:'18px', color: 'rgb(55, 173, 219)' }} type="dashboard" theme="filled" /><text style={{color:'#cc8e3b', fontSze:'16px',  paddingLeft: "10px", paddingRight:'20px'}}>{this.props.svrlocation.flight_departure_time} {this.props.svrlocation.flight_departure_daytime}</text><Icon type="line" /><text style={{ color: '#122196' }} style={{color:'#cc8e3b', fontSze:'16px', paddingLeft: "20px"}}>{this.props.svrlocation.flight_arrival_time} {this.props.svrlocation.flight_arrival_daytime}</text></span>
                                    
                                    <text style={{fontSize:'14px'}} className="svr-hotel-room d-block" > X {this.props.svrlocation.origincity}  ({this.props.svrlocation.origin_airport_code}) - {this.props.svrlocation.destcity} ({this.props.svrlocation.dst_airport_code}) </text>
                                    <span style={{fontSize: "14px"}} > <Icon  style={{ color: '#ca61a1', opacity:'0.9', fontSize:'16px' }} type="account-book" theme="filled" /><text style={{paddingLeft: "10px", color:'#898995'}}>{airlines_name}</text></span>
            
                                   </p>
                                </span>
                            
                        
            
                       
                    </span>
                </div>
                <div className="o-box-flist">
                    <span className="o-span">
                        
                                <p className="m-para-text">
                                <span style={{fontSize: "14px"}} > <text style={{fontSize:'14px',color:'#768999'}} >{flight_time_hhmm}</text><Icon style={{paddingLeft: "10px", color: 'rgb(126, 181, 230)' , fontSize:'14px'}} type="cloud-upload"   /><text style={{fontSize:'14px',color:'#768999',paddingLeft: "10px"}} >{flight_airline_num_stops} Stop</text></span>
                                    <text style={{fontSize:'14px'}} className="svr-hotel-room d-block"> 1h 42 m in DEN </text>
                                    <text style={{fontSize:'12px',color:'#898995'}} className="f12  d-block"> {fltight_name} </text>
                                </p>
                            
                    </span>
                </div>
                <div className="o-box-flist">
                    <span className="o-span">
                       
                            
                           
                                <p className="m-para-text">
                                
                                    <text style={{fontSize:'18px'}} className="svr-hotel-price d-block">$116 </text>
                                    <text style={{fontSize:'14px'}} className="svr-hotel-stay d-block">SVRound Trip per person</text>
                                    <span style={{fontSize: "12px"}} > <Icon style={{ color: '#122196' }} type="gift"  /><text style={{paddingLeft: "10px",  fonrSize:'13px', color:'#898995'}}>Save $2.67 SVPromoClub </text></span>
                                    {this.getFSKReserveHtmlButton(o,svcustProfile)
                                              
                                            }
                                        {/* 
                                    <Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svflysearch/svredfly/${o.flight_space_key}`}>Reserve  </Link></Button>
                                            */}
                                </p>
                            
                        
                    </span>
                </div>
               
               
            </div>
          
        )
    }

 
}


export default FlyLocationSVPriceListView